import type { RuntimeConfig } from "../config";

/** The support mailbox the public site lists; it stands in when the environment names no support page. */
const supportMailbox = "mailto:hello@nodus-compute.ai";

/** Where a customer reaches Nodus support about topic (Quota, Dispute, Other…): the environment's support page or
 * mailbox, else the site's support mailbox, with the topic as the email subject. The console has no support route
 * of its own. */
export function supportHref(config: RuntimeConfig, topic?: string): string {
  const url = config.supportURL ?? supportMailbox;
  if (!topic) return url;
  const sep = url.includes("?") ? "&" : "?";
  if (url.startsWith("mailto:")) return `${url}${sep}subject=${encodeURIComponent(`Nodus: ${topic}`)}`;
  return `${url}${sep}type=${encodeURIComponent(topic)}`;
}
